import type { VoidFunctionComponent } from 'react';

import { icons } from '../../../generic/Icon';
import { useCanManageTrustRelationship } from '../../shared/permissions';
import SettingsTableRowActions from '../../shared/SettingsTableRowActions';
import type { OIDCTrustRelationship } from '../../../../../shared/model-typings/oidctrustrelationship';

type TrustRelationshipActionMenuProps = {
  trustRelationship: OIDCTrustRelationship;
  onDeleteTrustRelationship: (id: number) => void;
  onViewTrustRelationship: (id: number) => void;
};

const TrustRelationshipActionMenu: VoidFunctionComponent<TrustRelationshipActionMenuProps> = ({
  trustRelationship,
  onDeleteTrustRelationship,
  onViewTrustRelationship,
}) => {
  const canManageThisTrustRelationship = useCanManageTrustRelationship(trustRelationship);

  return (
    <SettingsTableRowActions>
      <SettingsTableRowActions.IconButton
        tooltipId={`view-trust-relationship-${trustRelationship.id}`}
        tooltip="View"
        icon={icons.eyeRegular}
        onClick={() => onViewTrustRelationship(trustRelationship.id)}
      />
      {canManageThisTrustRelationship && <SettingsTableRowActions.IconButton
        tooltipId={`delete-trust-relationship-${trustRelationship.id}`}
        tooltip="Delete"
        icon={icons.trashRegular}
        onClick={() => onDeleteTrustRelationship(trustRelationship.id)}
      />}
    </SettingsTableRowActions>
  );
};

export default TrustRelationshipActionMenu;
